import * as firebase from 'firebase';
import { Investor } from '../modules/shared/models/investor';

export interface Roles {
  subscriber?: boolean;
  editor?: boolean;
  admin?: boolean;
  superAdmin?: boolean;
}

export interface User {
  uid: string;
  email: string;
  roles: Roles;
  displayName?: string;
  photoURL?: string;
}

export enum status { new = 'new', processing = 'processing', done = 'done', renew = 'renew' }

// export interface InvestorData {
//   iid?: string;
//   creatorId: string;
//   personName: string;
//   values?: Investor;
//   status: status;
//   createdAt?: firebase.firestore.FieldValue;
//   updatedAt: firebase.firestore.FieldValue;
// }



// WEBPACK FOOTER //
// ./src/app/core/user.ts